/**
 * Cookie Banner Configuration types + platform defaults.
 *
 * Re-exports the canonical CookieBannerConfig from @amuster/types
 * and defines the BANNER_DEFAULTS used when no tenant config is set.
 */

export type { CookieBannerConfig, CookieBannerCustomCopy } from '@amuster/types';

import type { CookieBannerConfig } from '@amuster/types';

export const BANNER_DEFAULTS: CookieBannerConfig = {
  position: 'bottom',
  theme: 'auto',
  accentToken: 'brand',
  showCategories: true,
  consentVersion: 1,
};
